/**
 * Activates Optimizely
 * @param {Number} counter The number of attempts we are currently at
 * @param {Function} activateOptimizely The function to try again with
 * @return {Undefined} Returns nothing
 */
export default function(counter, activateOptimizely) {
  const WAIT = 100;
  const MAX_COUNT = 20;

  if (typeof window !== 'undefined' && window.optimizely) {
    window.optimizely.push(['activate']);
  } else if (counter < MAX_COUNT) {
    setTimeout(() => {
      activateOptimizely(counter + 1, activateOptimizely);
    }, WAIT);
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/activateOptimizely.js